import React, { useEffect } from 'react'
import { hapticTick } from '../../../../../_utils/haptics'
import { useRecall } from '../useBeu'
import { Tick } from './icons'

// A question Bailey asks with answers to tap ("Set up your brand kit first,
// or make the post now?"). A tap sends that answer as theirs. The answers
// look the same (Ben, 6 Oct 2026: a dark one read as "the right answer"),
// lettered A, B, C in Bailey's order, so they're easy to tell apart.
// Once answered it shows what they chose; on an older reply nobody answered,
// the buttons are left out (the conversation has moved on).
const LETTERS = ['A', 'B', 'C']

// The answers on screen now, so typing "B" picks B (letteredAnswer)
let onScreen = null
export const letteredAnswer = (text) => {
  const m = /^\s*(?:option\s+)?([abc])\s*[.)!]?\s*$/i.exec(String(text || ''))
  if (!m || !onScreen) return null
  const c = onScreen[LETTERS.indexOf(m[1].toUpperCase())]
  return c ? c.label : null
}

const ChoicesWidget = ({ block, id, say }) => {
  const [done, setDone] = useRecall(id)
  if (done && done.chose) {
    return (
      <div className="bw-choices is-done" aria-live="polite">
        <span className="bw-status is-done"><Tick size={12} />{done.chose}</span>
      </div>
    )
  }
  if (!say) return null
  return <Answers block={block} setDone={setDone} say={say} />
}

const Answers = ({ block, setDone, say }) => {
  useEffect(() => {
    onScreen = block.items
    return () => { if (onScreen === block.items) onScreen = null }
  }, [block.items])
  // What they tapped is what's sent: the words on the button, nothing else
  const pick = (c) => { hapticTick(); setDone({ chose: c.label }); say(c.label) }
  return (
    <div className="bw-choices" role="group" aria-label="Choose one">
      {block.items.map((c, i) => (
        <button key={c.label} type="button" className="bw-choice" onClick={() => pick(c)}>
          <span className="bw-choice-letter" aria-hidden="true">{LETTERS[i]}</span>
          <span className="bw-choice-label">{c.label}</span>
        </button>
      ))}
    </div>
  )
}

export default ChoicesWidget
